export const SENTRY_TAG_KEYS = {
  tenantId: 'tenant_id',
  tenantGroupId: 'tenant_group_id',
  role: 'role',
  country: 'country',
  currency: 'currency',
  environment: 'environment',
  appRelease: 'app.release',
  httpStatus: 'http.status_code',
  httpStatusFamily: 'http.status_family',
  httpErrorKind: 'http.error_kind',
  userBlocking: 'user_blocking',
  httpMethod: 'http.method',
  httpUrl: 'http.url',
  httpRequestId: 'http.request_id',
} as const;

export const SENTRY_CONTEXT_KEYS = {
  tenant: 'tenant',
  organization: 'organization',
  route: 'route',
  http: 'http',
  app: 'app',
} as const;


export const SENTRY_BREADCRUMB_CATEGORIES = {
  xhr: 'xhr',
  fetch: 'fetch',
  navigation: 'navigation',
} as const;

export const SENTRY_BREADCRUMB_DATA_KEYS = {
  url: 'url',
  to: 'to',
  requestBody: 'request_body',
} as const;

export const SENTRY_HEADER_KEYS = {
  requestId: 'x-request-id',
  correlationId: 'x-correlation-id',
} as const;

export const SENTRY_USER_MESSAGE_KEYS = {
  unexpectedError: 'common.unexpectedError',
  networkError: 'common.networkError',
} as const;

export const SENTRY_SCRUB_FIELDS = [
  'authorization',
  'cookie',
  'x-api-key',
  'access_token',
  'id_token',
  'refresh_token',
  'password',
  'email',
] as const;

export const SENTRY_SCRUB_MARKER = '[Filtered]';

export const SENTRY_MAX_BODY_LENGTH = 2000;

export const SENTRY_TRACE_DEFAULT_TARGETS = ['localhost'] as const;
